export type AdminSuspensionHistoryEntry = {
  id: string;
  kind: "temporary_ban" | "permanent_ban" | "lifted";
  label: string;
  note: string | null;
  actorId: string | null;
  actorEmail: string | null;
  createdAt: string;
  days: number | null;
};

export function countPriorSuspensions(entries: AdminSuspensionHistoryEntry[]) {
  return entries.filter((entry) => entry.kind !== "lifted").length;
}

export function suspensionHistorySummary(entries: AdminSuspensionHistoryEntry[]) {
  const priorCount = countPriorSuspensions(entries);
  if (priorCount === 0) return null;
  if (priorCount === 1) return "Suspended once before";
  return `Suspended ${priorCount} times before`;
}
